import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { AuthConsumer } from '../context/AuthContext';
import { toast } from './Notifier';

class ForgotPassword extends Component {
	state = {
		user_login: '',
		error: '',
		loading: false,
	};

	handleResetPassword = (e, resetPassword) => {
		e.preventDefault();
		const { user_login } = this.state;
		if (user_login !== '') {
			this.setState({ loading: true });
			resetPassword({ user_login })
				.then((response) => {
					if (response && response.status === 'error') {
						let message =
							response.message ||
							"Couldn't reset password, check your network connectivity";
						toast(message, { status: 'error' });
						return this.setState({ error: message, loading: false });
					}
				})
				.catch((error) => {
					this.setState({
						loading: false,
					});
					toast("Couldn't reset password, check your network connectivity", {
						status: 'error',
					});
				});
		} else {
			toast('Email address or Matric Number cannot be empty', {
				status: 'error',
			});
			return this.setState({
				loading: false,
			});
		}
	};

	handleUserLoginChange = (e) => {
		this.setState({ [e.target.name]: e.target.value });
	};

	render() {
		return (
			<Fragment>
				<div className="container-fluid">
					<div className="row justify-content-center">
						{/* main content area */}
						<main className="login-box col col-12 col-xs-12 col-sm-10 col-md-9 col-lg-5 col-xl-5">
							<h1 className="text-center mt-5 pt-3">
								<Link to="/">
									<img
										src={require('../assets/logo_school.png')}
										width="auto"
										height={150}
										alt="Logo"
									/>
								</Link>
							</h1>
							{/* card for login box */}
							<div className="row no-gutters">
								<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<div className="card h-auto">
										<div className="card-body p-0">
											<form>
												<div className="login-form">
													<div className="login-title text-center">
														Forgot Password
													</div>
													<div className="login-container">
														<div className="form-group mb-35">
															<label htmlFor="exampleInputEmail1">
																Matric. Number / Email address
															</label>
															<input
																type="email"
																className="form-control"
																id="userlogin"
																name="user_login"
																aria-describedby="emailHelp"
																placeholder="Enter matric. number / email"
																onChange={this.handleUserLoginChange}
															/>
															{/* <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> */}
														</div>
														<div className="forgot-password">
															<Link to="/login">Return to Login Page</Link>
														</div>
													</div>
												</div>
												{/* button */}
												<div className="footer">
													{/* subtitute active class for disabled to either make button active or inactive */}
													<AuthConsumer>
														{({ resetPassword }) => (
															<button
																style={{
																	backgroundColor: this.state.loading
																		? '#02750e'
																		: '#00d715',
																}}
																className={[
																	`position-relative btn w-100 btn-primary-big btn-border-radius-login ${
																		this.state.loading ? 'disabled' : 'active'
																	}`,
																]}
																onClick={(e) =>
																	this.handleResetPassword(e, resetPassword)
																}
															>
																{this.state.loading ? (
																	<i className="fas fa-circle-notch fa-spin" />
																) : (
																	'Reset Password '
																)}
															</button>
														)}
													</AuthConsumer>
												</div>
											</form>
										</div>
									</div>
								</div>
							</div>
							{/* end card for login box  */}
						</main>
						{/* main content area */}
					</div>
				</div>
			</Fragment>
		);
	}
}

export default ForgotPassword;
